import $ from 'jquery'
import { send } from './utils/analytics'

export function initialise() {
  $(document).on('click', '[data-analytics]', function() {
    try {
      const event = JSON.parse($(this).attr('data-analytics'))
      send(event)
    } catch (err) {
      console.err('Could not parse/send analytics data', err)
    }
  })

  // $(document).on('load', function() {
  //   const eventView = $('[data-analtytics-pageview]')

  //   if (eventView.length) {
  //     try {
  //       const event = JSON.parse($(this).attr('data-analytics'))
  //       send(event)
  //     } catch (err) {
  //       console.err('Could not parse/send analytics data', err)
  //     }
  //   }
  // })
}
